<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_BranchBankAccount')"
      width="1000px"
      :close-on-click-modal="false"
      @close="removeHandler"
    >
      <cargo-ag-grid
        config-module="20220819"
        :grid-options="bankAccountDialog.gridOptions"
        :column-defs="bankAccountColumnDefs"
        :row-data="bankAccountDialog.rowData || []"
        style="width:100%;height:400px"
        @gridReady="params=>{gridApi=params.api}"
      />
      <div class="app-main-inner-row">
        <div class="filters" />
        <div class="triggers">
          <el-dropdown size="mini" :disabled="!bankAccountDialog.selectedData" @command="handleSetDefaultPayment">
            <el-button size="mini" type="primary">
              {{ $t('CargoMsg.Cargo_SetDefaultPaymentAccount') }} <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="cur in existingCurrencies"
                :key="cur"
                :command="cur"
              >{{ cur }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown size="mini" style="margin-left: 5px" :disabled="!bankAccountDialog.selectedData" @command="handleSetDefaultReceive">
            <el-button size="mini" type="primary">
              {{ $t('CargoMsg.Cargo_SetDefaultReceiveAccount') }} <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="cur in existingCurrencies"
                :key="cur"
                :command="cur"
              >{{ cur }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button size="mini" type="primary" style="margin-left: 5px" @click="popBankAccountAddDialog">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button
            size="mini"
            type="danger"
            :disabled="!bankAccountDialog.selectedData"
            @click="toBatchDelBankAccount"
          >{{ $t('CargoMsg.Cargo_Delete') }}
          </el-button>
          <el-button size="mini" type="primary" :disabled="!disabledSave" @click="commitBankAccount">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button size="mini" type="primary" @click="removeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { ApiCacheManage } from '@/utils/commonUtil'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getBankAccountList, saveOfficeBankAccount } from '@/api/bankAccount'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'BankAccountTitleWindow',
  components: { CargoAdvanceSelect, CargoAgGridAdvanceSelectEditor, CargoAgGridCommonInputEditor },
  props: {
    visible: { type: Boolean, required: true },
    treeNode: { type: Object, required: true },
    oneOffice: { type: Object, required: true }
  },
  data() {
    return {
      ourInvoiceTitleArray: [], // 我方发票抬头选项
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice), // getInvoiceTitlesByOffice缓存管理
      selectTypeNames: TYPE_NAMES,
      loading: false,
      gridApi: null,
      deleteList: [],
      disabledSave: false,
      bankAccountDialog: {
        isShow: false,
        isEditForm: false,
        gridOptions: {
          rowSelection: 'multiple',
          suppressRowClickSelection: true,
          singleClickEdit: true,
          onRowClicked: this.onRowClicked,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceMultipleSelectEditor
          }
        },
        gridParams: {},
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
        rowData: [],
        selectedData: null,
        oneBankAccount: {
          officeUuid: this.treeNode.uuid,
          accountId: '',
          accountNo: '',
          acrossTenant: '',
          bankAddress: '',
          bankChineseName: '',
          bankEnglishAddress: '',
          bankEnglishName: '',
          clientRefCode: '',
          code: '',
          createdBy: '',
          currency: '',
          dateCreated: '',
          dateModified: '',
          description: '',
          dirty: false,
          extendedData: '',
          modifiedBy: '',
          shortName: '',
          swiftCode: '',
          uuid: '',
          defaultPayment: false,
          defaultReceive: false,
          // 旧字段保留兼容
          defaultUsdAccount: false,
          defaultRmbAccount: false,
          defaultReceiveRmbAccount: false,
          defaultReceiveUsdAccount: false
        }
      }
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    },
    // 从表格数据中提取去重的币种列表，作为下拉选项
    existingCurrencies() {
      if (!this.bankAccountDialog.rowData || this.bankAccountDialog.rowData.length === 0) return []
      const currencies = new Set()
      this.bankAccountDialog.rowData.forEach(item => {
        if (item.currency) currencies.add(item.currency)
      })
      return Array.from(currencies)
    },
    bankAccountColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'currency',
          colId: 'currency',
          suppressMenu: true,
          width: 150,
          editable: true,
          hidden: false,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagName: 'code',
              selectType: TYPE_NAMES.basic_data_Currency,
              callbackParams: { key: 'code' },
              callbackMethodType: 'value',
              filterable: true
            }
          },
          valueFormatter: params => {
            return params.value
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.columnChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DefaultReceiveAccount'),
          field: 'defaultReceive',
          cellRenderer: params => {
            if (params.data && params.data.defaultReceive) {
              return '√'
            }
            return ''
          },
          hidden: false,
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_DefaultPaymentAccount'),
          field: 'defaultPayment',
          cellRenderer: params => {
            if (params.data && params.data.defaultPayment) {
              return '√'
            }
            return ''
          },
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DepositBank'), field: 'bankChineseName',
          colId: 'bankChineseName', suppressMenu: true,
          minWidth: 200,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_HeaderTitle'),
          field: 'officeInvoiceTitleUuid',
          colId: 'officeInvoiceTitleUuid',
          suppressMenu: true,
          minWidth: 220,
          editable: true,
          hide: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.static_data_InvoiceTitle,
              filterable: true,
              cache: false,
              staticOptions: this.ourInvoiceTitleArray || [],
              tagValue: 'uuid'
            }
          },
          valueFormatter: params => {
            // return params.value
            return ColumnUtils.getInvoiceTitleLabel(params.value, this.ourInvoiceTitleArray)
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.columnChange(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BankCode'), field: 'openBankAccount',
          colId: 'openBankAccount', suppressMenu: true,
          minWidth: 220,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'), field: 'code',
          colId: 'code', suppressMenu: true,
          minWidth: 80,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ShortName'), field: 'shortName',
          colId: 'shortName', suppressMenu: true,
          minWidth: 80,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'), field: 'bankEnglishName',
          colId: 'bankEnglishName', suppressMenu: true,
          minWidth: 80,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        },
        {
          headerName: 'SWIFT', field: 'swiftCode',
          colId: 'swiftCode', suppressMenu: true,
          minWidth: 80,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountNumber'), field: 'accountNo',
          colId: 'accountNo', suppressMenu: true,
          minWidth: 80,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.columnChange(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Instructions'), field: 'description',
          colId: 'description', suppressMenu: true,
          minWidth: 180,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BankChineseAddress'), field: 'bankAddress',
          colId: 'bankAddress', suppressMenu: true,
          minWidth: 180,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BankEnglishAddress'), field: 'bankEnglishAddress',
          colId: 'bankEnglishAddress', suppressMenu: true,
          minWidth: 180,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        }
      ]
    }
  },
  async beforeMount() {

  },
  mounted() {
    this.getBankList()
    // 获取发票抬头列表
    this.getInvoiceTitlesByOfficeCache.execute({ officeId: this.oneOffice.officeId }).then(res => {
      this.ourInvoiceTitleArray = res.data
    })
  },
  methods: {
    // 设置默认付款账号（通用）
    handleSetDefaultPayment(currency) {
      const data = this.bankAccountDialog.selectedData
      if (data.currency !== currency) {
        this.$message.warning(this.$t('SystemMaintenance.TheItCannotBeAccount'))
        return
      }
      this.clearDefaultByType('payment', currency)
      data.defaultPayment = true
      // 兼容旧字段
      if (currency === 'RMB') data.defaultRmbAccount = true
      if (currency === 'USD') data.defaultUsdAccount = true
      this.gridApi.refreshCells({ force: true })
      if (!this.oneOffice.multiTitleBankMode) {
        // 兼容旧 Office 字段
        if (currency === 'RMB') this.oneOffice.rmbAccount = data.accountNo
        if (currency === 'USD') this.oneOffice.usdAccount = data.accountNo
      }
    },
    // 设置默认收款账号（通用）
    handleSetDefaultReceive(currency) {
      const data = this.bankAccountDialog.selectedData
      if (data.currency !== currency) {
        this.$message.warning(this.$t('SystemMaintenance.TheItCannotBeAccount'))
        return
      }
      this.clearDefaultByType('receive', currency)
      data.defaultReceive = true
      // 兼容旧字段
      if (currency === 'RMB') data.defaultReceiveRmbAccount = true
      if (currency === 'USD') data.defaultReceiveUsdAccount = true
      this.gridApi.refreshCells({ force: true })
      if (!this.oneOffice.multiTitleBankMode) {
        if (currency === 'RMB') this.oneOffice.receiveRmbAccount = data.accountNo
        if (currency === 'USD') this.oneOffice.receiveUsdAccount = data.accountNo
      }
    },
    popBankAccountAddDialog() {
      if (!this.bankAccountDialog.rowData) {
        this.bankAccountDialog.rowData = []
      }
      const data = {
        officeInvoiceTitleUuid: '',
        openBankAccount: '',
        officeUuid: this.treeNode.uuid,
        accountId: '',
        accountNo: '',
        acrossTenant: '',
        bankAddress: '',
        bankChineseName: '',
        bankEnglishAddress: '',
        bankEnglishName: '',
        clientRefCode: '',
        code: '',
        createdBy: '',
        currency: '',
        dateCreated: '',
        dateModified: '',
        description: '',
        dirty: false,
        extendedData: '',
        modifiedBy: '',
        shortName: '',
        swiftCode: '',
        uuid: '',
        defaultPayment: false,
        defaultReceive: false,
        // 旧字段保留兼容
        defaultUsdAccount: false,
        defaultRmbAccount: false,
        defaultReceiveRmbAccount: false,
        defaultReceiveUsdAccount: false
      }
      this.bankAccountDialog.rowData.push(data)
      this.disabledSave = true
    },
    async commitBankAccount() {
      this.loading = getLoading()
      const tips = await this.checkForm()
      if (tips === 'false') {
        this.loading.close()
        console.log('.校验失败....')
      } else if (tips !== '') {
        this.loading.close()
        await this.$confirm('[' + tips + this.$t('SystemMaintenance.NameDoYouWantSave'), this.$t('SystemMaintenance.Prompt'), {
          confirmButtonText: this.$t('SystemMaintenance.OK'),
          cancelButtonText: this.$t('SystemMaintenance.Cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = getLoading()
          this.doSaveBankAccount()
        })
      } else {
        this.doSaveBankAccount()
      }
    },
    doSaveBankAccount() {
      const c = {
        bankAccountVOList: this.bankAccountDialog.rowData,
        officeUuid: this.treeNode.uuid,
        defaultRmb: this.oneOffice.rmbAccount,
        defaultUsd: this.oneOffice.usdAccount,
        defaultReceiveRmb: this.oneOffice.receiveRmbAccount,
        defaultReceiveUsd: this.oneOffice.receiveUsdAccount,
        deleteList: this.deleteList
      }
      saveOfficeBankAccount(c).then(res => {
        this.deleteList = []
        this.getBankList()
        this.$confirm(this.$t('SystemMaintenance.SaveWantToCloseWindow'), this.$t('SystemMaintenance.Prompt'), {
          confirmButtonText: this.$t('SystemMaintenance.OK'),
          cancelButtonText: this.$t('SystemMaintenance.Cancel'),
          type: 'warning'
        }).then(() => {
          this.removeHandler()
        })
      }).finally((e) => {
        this.loading.close()
      })
    },
    async checkForm() {
      const nameCount = {}
      let tips = ''
      if (this.bankAccountDialog.rowData && this.bankAccountDialog.rowData.length > 0) {
        for (const r of this.bankAccountDialog.rowData) {
          if (!r.currency) {
            this.$message.warning(this.$t('SystemMaintenance.CurrencyCannotBeEmpty'))
            return 'false'
          }
          if (!r.code) {
            this.$message.warning(this.$t('SystemMaintenance.CodeCannotBeEmpty'))
            return 'false'
          }
          if (!r.bankEnglishName) {
            this.$message.warning(this.$t('SystemMaintenance.EnglishNameCannotBeEmpty'))
            return 'false'
          }
          if (!r.accountNo) {
            this.$message.warning(this.$t('SystemMaintenance.AccountNumberCannotBeEmpty'))
            return 'false'
          }
          nameCount[r.bankChineseName] = (nameCount[r.bankChineseName] || 0) + 1
        }
        const keys = Object.keys(nameCount)
        keys.forEach(key => {
          if (nameCount[key] > 1) {
            if (tips) {
              tips += ','
            }
            tips += key
          }
        })
      }
      return tips
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.bankAccountDialog.selectedData = event.data
    },
    getBankList() {
      this.loading = getLoading()
      getBankAccountList(this.treeNode.uuid).then(res => {
        this.bankAccountDialog.rowData = res.data
        if (!this.oneOffice.multiTitleBankMode && this.bankAccountDialog.rowData && this.bankAccountDialog.rowData.length > 0) {
          for (const item of this.bankAccountDialog.rowData) {
            // 优先使用后端返回的通用字段，兼容旧逻辑 fallback
            if (item.defaultPayment === undefined || item.defaultPayment === null) {
              item.defaultPayment = item.defaultRmbAccount || item.defaultUsdAccount || false
            }
            if (item.defaultReceive === undefined || item.defaultReceive === null) {
              item.defaultReceive = item.defaultReceiveRmbAccount || item.defaultReceiveUsdAccount || false
            }
            // 兼容旧逻辑：从 oneOffice 字段推断
            item.defaultRmbAccount = this.setDefaultAccount(item, 'rmbAccount')
            item.defaultUsdAccount = this.setDefaultAccount(item, 'usdAccount')
            item.defaultReceiveRmbAccount = this.setDefaultAccount(item, 'receiveRmbAccount')
            item.defaultReceiveUsdAccount = this.setDefaultAccount(item, 'receiveUsdAccount')
          }
        }
        if (res.data && res.data.length > 0) {
          this.disabledSave = true
        } else {
          this.disabledSave = false
        }
      }).finally((e) => {
        this.loading.close()
      })
    },
    toBatchDelBankAccount() {
      if (this.bankAccountDialog.selectedData) {
        const index = this.bankAccountDialog.rowData.findIndex(p => p.uuid === this.bankAccountDialog.selectedData.uuid)
        console.log('index:', index)
        if (index > -1) {
          this.deleteList.push(this.bankAccountDialog.selectedData.uuid)
          console.log('this.deleteList:', this.deleteList)
          this.bankAccountDialog.rowData.splice(index, 1)
          this.bankAccountDialog.selectedData = null
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
      }
    },
    removeHandler() {
      this.$emit('update:visible', false)
    },
    columnChange(params) {
      const field = params && params.colDef ? params.colDef.field : ''
      if (this.oneOffice.multiTitleBankMode) {
        if (['currency', 'officeInvoiceTitleUuid'].indexOf(field) > -1 && params && params.data) {
          params.data.defaultPayment = false
          params.data.defaultReceive = false
          params.data.defaultRmbAccount = false
          params.data.defaultUsdAccount = false
          params.data.defaultReceiveRmbAccount = false
          params.data.defaultReceiveUsdAccount = false
          this.gridApi.refreshCells({ force: true })
        }
      } else {
        if (['currency', 'accountNo'].indexOf(field) > -1 && params && params.data) {
          const currency = params.data.currency
          params.data.defaultPayment = currency && !this.hasDefaultByType('payment', currency)
          params.data.defaultReceive = currency && !this.hasDefaultByType('receive', currency)
          // 兼容旧字段
          params.data.defaultRmbAccount = currency === 'RMB' && !this.hasDefaultAccount('rmbAccount')
          params.data.defaultUsdAccount = currency === 'USD' && !this.hasDefaultAccount('usdAccount')
          params.data.defaultReceiveRmbAccount = currency === 'RMB' && !this.hasDefaultAccount('receiveRmbAccount')
          params.data.defaultReceiveUsdAccount = currency === 'USD' && !this.hasDefaultAccount('receiveUsdAccount')
          this.gridApi.refreshCells({ force: true })
        }
      }
    },
    // 清空指定类型和币种的默认标记
    clearDefaultByType(type, currency) {
      if (this.bankAccountDialog.rowData && this.bankAccountDialog.rowData.length > 0) {
        for (const item of this.bankAccountDialog.rowData) {
          // 多抬头模式，需要过滤相同抬头的银行账号
          if (!this.oneOffice.multiTitleBankMode || (this.bankAccountDialog.selectedData.officeInvoiceTitleUuid === item.officeInvoiceTitleUuid)) {
            if (item.currency === currency) {
              if (type === 'payment') {
                item.defaultPayment = false
                // 兼容旧字段
                if (currency === 'RMB') item.defaultRmbAccount = false
                if (currency === 'USD') item.defaultUsdAccount = false
              }
              if (type === 'receive') {
                item.defaultReceive = false
                if (currency === 'RMB') item.defaultReceiveRmbAccount = false
                if (currency === 'USD') item.defaultReceiveUsdAccount = false
              }
            }
          }
        }
      }
    },
    // 旧方法保留兼容：清空默认银行账号
    clearDefaultAccount(field) {
      if (this.bankAccountDialog.rowData && this.bankAccountDialog.rowData.length > 0) {
        for (const item of this.bankAccountDialog.rowData) {
          // 多抬头模式，需要过滤 相同抬头的 银行账号
          if (!this.oneOffice.multiTitleBankMode || (this.bankAccountDialog.selectedData.officeInvoiceTitleUuid === item.officeInvoiceTitleUuid &&
            this.bankAccountDialog.selectedData.currency === item.currency)) {
            if (field === 'rmbAccount') {
              item.defaultRmbAccount = false
            } else if (field === 'usdAccount') {
              item.defaultUsdAccount = false
            } else if (field === 'receiveRmbAccount') {
              item.defaultReceiveRmbAccount = false
            } else if (field === 'receiveUsdAccount') {
              item.defaultReceiveUsdAccount = false
            }
          }
        }
      }
    },
    // 列表渲染的时候，设置默认的银行账号（旧逻辑保留兼容）
    setDefaultAccount(data, field) {
      if (data && this.oneOffice) {
        if (field === 'rmbAccount' && data.currency === 'RMB' && this.oneOffice.rmbAccount && data.accountNo === this.oneOffice.rmbAccount) {
          return true
        } else if (field === 'usdAccount' && data.currency === 'USD' && this.oneOffice.usdAccount && data.accountNo === this.oneOffice.usdAccount) {
          return true
        } else if (field === 'receiveRmbAccount' && data.currency === 'RMB' && this.oneOffice.receiveRmbAccount && data.accountNo === this.oneOffice.receiveRmbAccount) {
          return true
        } else if (field === 'receiveUsdAccount' && data.currency === 'USD' && this.oneOffice.receiveUsdAccount && data.accountNo === this.oneOffice.receiveUsdAccount) {
          return true
        }
      }
      return false
    },
    // 检查指定类型和币种是否已有默认账号
    hasDefaultByType(type, currency) {
      let hasDefault = false
      if (this.bankAccountDialog.rowData && this.bankAccountDialog.rowData.length > 0) {
        for (const item of this.bankAccountDialog.rowData) {
          if (item.currency === currency) {
            if (type === 'payment' && item.defaultPayment) hasDefault = true
            if (type === 'receive' && item.defaultReceive) hasDefault = true
          }
          if (hasDefault) break
        }
      }
      return hasDefault
    },
    // 旧方法保留兼容：是否有默认的银行账号
    hasDefaultAccount(field) {
      let hasDefault = false
      if (this.bankAccountDialog.rowData && this.bankAccountDialog.rowData.length > 0) {
        for (const item of this.bankAccountDialog.rowData) {
          if (field === 'rmbAccount' && item.currency === 'RMB' && item.defaultRmbAccount) hasDefault = true
          if (field === 'usdAccount' && item.currency === 'USD' && item.defaultUsdAccount) hasDefault = true
          if (field === 'receiveRmbAccount' && item.currency === 'RMB' && item.defaultReceiveRmbAccount) hasDefault = true
          if (field === 'receiveUsdAccount' && item.currency === 'USD' && item.defaultReceiveUsdAccount) hasDefault = true
          if (hasDefault) break
        }
      }
      return hasDefault
    }
  }
}
</script>
